import React from 'react';
import { useT } from 'react-polyglot-hooks';
import ConfirmModal from '../ConfirmModal';

interface ConfirmBasicProps {
    onClose: () => void;
    onConfirmClick: () => void;
    open: boolean;
    title: string;
    message: string;
    submitIsDelete?: boolean;
}

const ConfirmBasic = (props: ConfirmBasicProps) => {
    const {
        open,
        onClose,
        onConfirmClick,
        title,
        message,
        submitIsDelete
    } = props;
    const t = useT();

    return (
        <ConfirmModal
            onClose={onClose}
            onConfirmClick={onConfirmClick}
            open={open}
            title={String(t(title))}
            message={String(t(message))}
            submitIsDelete={submitIsDelete}
        />
    );
};

export default ConfirmBasic;
